import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const marketplaceRoutes: RouteRecordRaw[] = [
  {
    path: routes.MARKETPLACE,
    name: 'MARKETPLACE',
    component: () => import('./MarketplacePage.vue'),
    meta: { requiresAuth: true, title: 'Marketplace' },
  },
]
